import { ApprovalUserRole, ReportType, ApprovalState } from '@fdm/api-client';
import { ReportFormPage } from '../../report-form-control.service';

export const FASTREPI_POlICY = {
  [ApprovalUserRole.FastRepi]: {
    [ReportType.AnomalyReport]: {
      [ReportFormPage.RIPT]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.PlanConfirmed,
        ApprovalState.PlanApproved,
        ApprovalState.ResolutionPlanCompleted,
        ApprovalState.ValidationAndVerificationCompleted,
      ],
    },
    [ReportType.IntegrityDeficiency]: {
      [ReportFormPage.RIPT]: [ApprovalState.PlanConfirmed],
      [ReportFormPage.RISK_EVALUATION]: [ApprovalState.SubmittedToOpsAdvisor],
    },
    [ReportType.ReliabilityDeficiency]: {
      [ReportFormPage.RIPT]: [ApprovalState.PlanConfirmed],
      [ReportFormPage.RISK_EVALUATION]: [ApprovalState.SubmittedToOpsAdvisor],
    },
    [ReportType.IntegrityThreat]: {
      [ReportFormPage.RIPT]: [ApprovalState.PlanConfirmed],
    },
    [ReportType.ReliabilityThreat]: {
      [ReportFormPage.RIPT]: [ApprovalState.PlanConfirmed],
    },
    [ReportType.TaskDeferral]: {
      [ReportFormPage.RISK_EVALUATION]: [ApprovalState.SubmittedToOpsAdvisor],
    },
  },
};
